import * as H from 'history';
import * as React from 'react';
import { Link, Route, useParams } from 'react-router-dom';
import { Container, Nav, NavItem, NavLink } from 'reactstrap';

import { authAxios } from '../../services/AxiosService';
import { DepartmentDetails } from './DepartmentDetails';
import { IDepartment } from '../../contexts/DomainContext';
import { useEffect, useState } from 'react';
import { useWindowDimensions } from '../../hooks/WindowHooks';
import { useHistory } from 'react-router';

export const Department = () => {
  const [department, setDepartment] = useState<IDepartment | undefined>(undefined);
  const params = useParams<{ departmentId: string; tab?: string }>();
  const history = useHistory();
  const departmentId = params.departmentId;
  const { xs, sm } = useWindowDimensions();
  const verticalMenu = xs || sm;

  useEffect(() => {
    authAxios
      .get('/api/departments/' + departmentId)
      .then((response) => {
        if (response.data && response.data.status && response.data.status.includes('KO')) {
          history.push('/404');
        } else {
          setDepartment(response.data);
        }
      })
      .catch((response) => {
        history.push('/404');
      });
  }, [departmentId]);

  const tab: string = params.tab || 'details';

  const NavItemLink = (to: H.LocationDescriptor, active: boolean, name: any) => {
    return (
      <NavItem>
        <NavLink tag={Link} to={to} active={active}>
          {name}
        </NavLink>
      </NavItem>
    );
  };

  return (
    <article className='page'>
      <div className={'page-header-image'} />
      <header className='page-header'>
        <Container fluid={true}>
          {department !== undefined && (
            <div className='d-flex flex-column'>
              <h3 className='page-header__title order-2'>{department.name}</h3>
              <h5 className='page-header__id order-1 text-primary'>{department.email}</h5>
            </div>
          )}
          <div className={verticalMenu ? 'd-block d-md-none pb-4' : 'd-none d-md-block'}>
            <Nav tabs={!verticalMenu} pills={verticalMenu} vertical={verticalMenu}>
              {NavItemLink('/departments/' + params.departmentId + '/details', tab === 'details', 'Details')}
            </Nav>
          </div>
        </Container>
      </header>

      <div style={{ backgroundColor: 'white' }}>
        <Route exact={true} path='/departments/:departmentId/(details)?' component={DepartmentDetails} />
      </div>
    </article>
  );
};
